export default __webpack_public_path__ + "static/media/10054cc460c2cf9a.36a854fc9ee9b126595cf434f19b9917.svg";